import { css } from 'lit';

export const postReaderStyles = css`
  :host {
    display: block;
  }

  .back-btn {
    background: none;
    border: none;
    color: var(--accent-color, #245590);
    font-family: var(--font-mono, monospace);
    font-size: 0.9rem;
    cursor: pointer;
    padding: 0;
    margin-bottom: 1.5rem;
    display: inline-flex;
    align-items: center;
    gap: 0.3rem;
  }

  .back-btn:hover {
    text-decoration: underline;
  }

  .article-header {
    margin-bottom: 2rem;
    border-bottom: 1px solid var(--border-color, #e5e5de);
    padding-bottom: 1.25rem;
  }

  h1 {
    font-family: var(--font-serif, serif);
    font-size: 2.1rem;
    font-weight: 700;
    line-height: 1.25;
    color: var(--text-primary, #1a1a18);
    margin-bottom: 0.6rem;
  }

  .meta-row {
    font-family: var(--font-mono, monospace);
    font-size: 0.8rem;
    color: var(--text-muted, #7c7c75);
    display: flex;
    gap: 0.6rem;
    align-items: center;
    flex-wrap: wrap;
  }

  .type-badge {
    text-transform: uppercase;
    font-size: 0.72rem;
    letter-spacing: 0.05em;
    background: var(--bg-secondary, #f6f6f2);
    padding: 0.15rem 0.45rem;
    border-radius: 3px;
    border: 1px solid var(--border-color, #e5e5de);
  }

  /* Full-Page Password Modal Overlay */
  .password-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: var(--bg-primary, #fafaf7);
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1.5rem;
    box-sizing: border-box;
  }

  .password-modal-card {
    background: var(--bg-secondary, #f6f6f2);
    border: 1px solid var(--border-color, #e5e5de);
    border-radius: 8px;
    padding: 1.4rem 1.6rem 1.6rem 1.6rem;
    width: 100%;
    max-width: 440px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);
    box-sizing: border-box;
  }

  .modal-top-bar {
    margin-top: 0;
    margin-bottom: 0.75rem;
    margin-left: -0.2rem;
    display: flex;
    align-items: center;
  }

  .modal-title {
    font-family: var(--font-serif, serif);
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1.3;
    color: var(--text-primary, #1a1a18);
    margin: 0 0 0.25rem 0;
  }

  .modal-subtitle {
    font-family: var(--font-mono, monospace);
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: var(--text-muted, #7c7c75);
    margin: 0 0 1.35rem 0;
  }

  .password-form {
    display: flex;
    flex-direction: column;
    gap: 0.6rem;
  }

  .input-row {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    height: 40px;
  }

  .password-input-wrapper {
    flex: 1;
    position: relative;
    display: flex;
    align-items: center;
    height: 40px;
  }

  .password-input-wrapper .password-input {
    width: 100%;
    height: 40px;
    font-family: var(--font-mono, monospace);
    font-size: 0.9rem;
    padding: 0 2.2rem 0 0.85rem;
    border: 1px solid var(--border-color, #e5e5de);
    border-radius: 4px;
    background: var(--bg-primary, #ffffff);
    color: var(--text-primary, #1a1a18);
    outline: none;
    box-sizing: border-box;
    transition: border-color 0.15s ease;
  }

  .password-input-wrapper .password-input:focus {
    border-color: var(--accent-color, #245590);
  }

  .toggle-password-btn {
    position: absolute;
    right: 0.5rem;
    background: none;
    border: none;
    padding: 0.25rem;
    color: var(--text-muted, #7c7c75);
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 3px;
    transition: color 0.15s ease;
  }

  .toggle-password-btn:hover {
    color: var(--text-primary, #1a1a18);
  }

  .input-row app-button {
    height: 40px;
    display: inline-flex;
  }

  .error-msg {
    color: #d9383a;
    font-size: 0.82rem;
    font-family: var(--font-mono, monospace);
    margin-top: 0.15rem;
  }

  .content-area {
    font-size: 1.05rem;
    line-height: 1.75;
    color: var(--text-primary, #1a1a18);
  }
`;
